enum MixpanelTracks {
  LogIn = 'LogIn',
  LogOut = 'LogOut',
  // Case
  CaseListView = 'CaseListView',
  CaseCreated = 'CaseCreated',
  CaseApproved = 'CaseApproved',
  CaseRejected = 'CaseRejected',
  CaseArchived = 'CaseArchived',
  CaseUnarchived = 'CaseUnarchived',
  CaseDeleted = 'CaseDeleted',
  CaseLabelsUpdated = 'CaseLabelsUpdated',
  CaseNotesUpdated = 'CaseNotesUpdated',
  CaseDetailsUpdated = 'CaseDetailsUpdated',

  CaseSearchExecute = 'CaseSearchExecute',

  CaseReportCreated = 'CaseReportCreated',
  CaseReportShared = 'CaseReportShared',
  CaseReportRemoved = 'CaseReportRemoved',

  CaseTimelineView = 'CaseTimelineView',
  CaseTimelineFilter = 'CaseTimelineFilter',
  CaseTimelineExported = 'CaseTimelineExported',
  CaseTimelineLegendView = 'CaseTimelineLegendView',

  CaseCalendarFilter = 'CaseCalendarFilter',
  CaseCalendarExported = 'CaseCalendarExported',

  CaseSinglePageOpen = 'CaseSinglePageOpen',

  CaseSharesView = 'CaseSharesView',
  CaseShareCreated = 'CaseShareCreated',
  CaseShareAccessView = 'CaseShareAccessView',
  CaseShareAccessAdded = 'CaseShareAccessAdded',
  CaseShareAccessRevoked = 'CaseShareAccessRevoked',

  CaseDocumentsExports = 'CaseDocumentsExports',

  PagesCompareView = 'PagesCompareView',

  CaseDocumentFilter = 'CaseDocumentFilter',
  CaseWorkspaceFilter = 'CaseWorkspaceFilter',

  CaseView = 'CaseView',
  CaseFilesView = 'CaseFilesView',
  CaseWorkspaceView = 'CaseWorkspaceView',
  CaseDuplicatesView = 'CaseDuplicatesView',
  CaseCalendarView = 'CaseCalendarView',
  CaseReportsView = 'CaseReportsView',
  CaseMessagesView = 'CaseMessagesView',
  CaseInvoicesView = 'CaseInvoicesView',
  CaseSearchView = 'CaseSearchView',
  CaseMessagesCreateConversationAction = 'CaseMessagesCreateConversationAction',
  CaseMessagesSendMessageAction = 'CaseMessagesSendMessageAction',
  CaseDocumentOpen = 'CaseDocumentOpen',
  CasePageOpen = 'CasePageOpen',
  CasePageUpdate = 'CasePageUpdate',
  CasePagesUpdate = 'CasePagesUpdate',
  CaseEpisodeAdd = 'CaseEpisodeAdd',
  CaseEpisodeUpdate = 'CaseEpisodeUpdate',
  CaseEpisodeDelete = 'CaseEpisodeDelete',
  CasePageRotate = 'CasePageRotate',

  AuthorCreate = 'AuthorCreate',
  AuthorDelete = 'AuthorDelete',
  AuthorUpdate = 'AuthorUpdate',

  CaseEpisodeFactAdded = 'CaseEpisodeFactAdded',
  CaseEpisodeFactUpdated = 'CaseEpisodeFactUpdated',
  CaseEpisodeFactDeleted = 'CaseEpisodeFactDeleted',
  CaseEpisodeFactCodeLookup = 'CaseEpisodeFactCodeLookup',

  OutdatedPageUpdateAttempt = 'OutdatedPageUpdateAttempt',

  PageMarkedNotADUplicate = 'PageMarkedNotADUplicate',
  ClusterMarkedNotADuplicate = 'ClusterMarkedNotADuplicate',

  InstantWorkflowRun = 'InstantWorkflowRun',

  // Campaign
  CampaignLandingPageOpened = 'CampaignLandingPageOpened',
  CampaignRegistrationStarted = 'CampaignRegistrationStarted',
  CampaignRegistrationVerificationStarted = 'CampaignRegistrationVerificationStarted',
  CampaignRegistrationCompleted = 'CampaignRegistrationCompleted',
  CampaignRecordsUploaded = 'CampaignRecordsUploaded',
};

export default MixpanelTracks;
